'use client';

const newWindowIndication = "(Opens in new window)";
export {
  newWindowIndication
};
